// extracted by mini-css-extract-plugin
export default {"botoesContainer":"categorias_botoesContainer__Z8tag","botoes":"categorias_botoes__8f9Z4"};